import { useQyGetActivityLogByPatient } from "@factory/query/activity-log.query";
import ErrorSection from "@shared/ui/error-section/error-section";
import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import ActivityTimeline from "@shared/ui/timeline/timeline";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { useParams } from "react-router-dom";

export function HistoryPatient() {
  const { patientId } = useParams();
  const { formatDateTimeLocal } = useDateTimeContext();

  const {
    data: activityLogResponse,
    isLoading,
    isError,
  } = useQyGetActivityLogByPatient(
    patientId || "",
    "",
    100,
    0,
    undefined,
    undefined,
    !!patientId,
  );

  if (isLoading) {
    return (
      <div className="card">
        <SkeletonList count={4} />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="card">
        <ErrorSection
          title="Error Loading History"
          message="Unable to load patient history. Please try again."
        />
      </div>
    );
  }

  if (!activityLogResponse?.data || activityLogResponse.data.length === 0) {
    return (
      <div className="card">
        <ErrorSection
          title="No History"
          message="No activity history found for this patient."
        />
      </div>
    );
  }

  return (
    <div className="card">
      <h3 className="mb-4">Activity History</h3>
      <ActivityTimeline
        data={activityLogResponse.data}
        formatDateTime={formatDateTimeLocal}
      />
    </div>
  );
}

export default HistoryPatient;
